import leftBorder from '../../assets/images/topborder.svg';
import rightBorder from '../../assets/images/topborder.svg';

export default function (props) {
    return <div {...props}>
        <div className='hadis-section  '>
            <img src={rightBorder} className="hadis-border" alt=""/>
            <div className='hadis-box'>
                {props.children}
            </div>
            <img src={leftBorder} className="left-border hadis-border" alt=""/>
        </div>
    </div>
}
